var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: {
          cx: "20",
          cy: "20",
          r: "20",
          fill: _vm.color,
          "fill-opacity": "0.2"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M20 10C14.49 10 10 14.49 10 20C10 25.51 14.49 30 20 30C25.51 30 30 25.51 30 20C30 14.49 25.51 10 20 10ZM23.36 22.3C23.65 22.59 23.65 23.07 23.36 23.36C23.21 23.51 23.02 23.58 22.83 23.58C22.64 23.58 22.45 23.51 22.3 23.36L20 21.06L17.7 23.36C17.55 23.51 17.36 23.58 17.17 23.58C16.98 23.58 16.79 23.51 16.64 23.36C16.35 23.07 16.35 22.59 16.64 22.3L18.94 20L16.64 17.7C16.35 17.41 16.35 16.93 16.64 16.64C16.93 16.35 17.41 16.35 17.7 16.64L20 18.94L22.3 16.64C22.59 16.35 23.07 16.35 23.36 16.64C23.65 16.93 23.65 17.41 23.36 17.7L21.06 20L23.36 22.3Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }